import { teamConstants } from '../Constants'
const teamReducer = (state = {}, action) => {
  switch (action.type) {
    case teamConstants.TEAM_SUCCESS:
      return action.payload;
    case teamConstants.TEAM_FAILURE:
      return {};
    default:
      return state;
  }
}

export default teamReducer;